import { useEffect, useMemo, useState } from 'react';

export default function useIsLTE650(breakpoint = 650): boolean {
    const query = useMemo(() => `(max-width: ${breakpoint}px)`, [breakpoint]);
    const getMatch = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
    const [isMatch, setIsMatch] = useState<boolean>(getMatch);
    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
        const mql = window.matchMedia(query);
        setIsMatch(mql.matches);
        const handler = (e: MediaQueryListEvent) => setIsMatch(e.matches);
        if (typeof mql.addEventListener === 'function') {
            mql.addEventListener('change', handler);
            return () => mql.removeEventListener('change', handler);
        }
        mql.addListener(handler);
        return () => {
            mql.removeListener(handler);
        };
    }, [query]);
    return isMatch;
}
